module.exports = __webpack_public_path__ + "NanumSquareL.f2a56a3bef1a85a94f09";


//////////////////
// WEBPACK FOOTER
// /Users/gygo/zzal/src_brand_web/src/assets/font/NanumSquareL.ttf
// module id = ../../../../../src/assets/font/NanumSquareL.ttf
// module chunks = styles